export default {
    goodMorning: 'Good Morning',
    goodAfternoon: 'Good After Noon',
    goodEvening: 'Good Evening'
}
